var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTicketEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "edit (1) 2",
    clipPath: "url(#clip0_17_2258)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.16699 3.33203H3.33366C2.89163 3.33203 2.46771 3.50763 2.15515 3.82019C1.84259 4.13275 1.66699 4.55667 1.66699 4.9987V16.6654C1.66699 17.1074 1.84259 17.5313 2.15515 17.8439C2.46771 18.1564 2.89163 18.332 3.33366 18.332H15.0003C15.4424 18.332 15.8663 18.1564 16.1788 17.8439C16.4914 17.5313 16.667 17.1074 16.667 16.6654V10.832",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M15.417 2.08417C15.7485 1.75265 16.1982 1.56641 16.667 1.56641C17.1358 1.56641 17.5855 1.75265 17.917 2.08417C18.2485 2.41569 18.4348 2.86533 18.4348 3.33417C18.4348 3.80301 18.2485 4.25265 17.917 4.58417L10.0003 12.5008L6.66699 13.3342L7.50033 10.0008L15.417 2.08417Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17_2258"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicketEdit);
export default __webpack_public_path__ + "static/media/ticket-edit.1207bb4b20299c84da24ccb20dc99c45.svg";
export { ForwardRef as ReactComponent };